import axios from 'axios'
import util from '../util/asymmetric'

let token = util.asymmetric()

const instance = axios.create({

  baseURL: process.env.VUE_APP_OPEN_ROUTER_API ,
  headers: {
    token: token,
  },
})

export default instance